import { render, staticRenderFns } from "./ClientsEditPage.vue?vue&type=template&id=11573133&"
import script from "./ClientsEditPage.vue?vue&type=script&lang=js&"
export * from "./ClientsEditPage.vue?vue&type=script&lang=js&"
import style0 from "./ClientsEditPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports